<template>
  <div>
    <b-form @submit="edit">
      <b-row>
        <b-col cols="12">
          <label class="text-grey">SKU</label>
          <b-form-input
            disabled
            type="text"
            :value="sku"
            v-on:input="$emit('update:sku', $event)"
            placeholder="Escriba aquí"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="padding-two-top">
          <label class="text-grey">Descripción</label>
          <b-form-input
            type="text"
            :value="description"
            v-on:input="$emit('update:description', $event)"
            placeholder="Escriba aquí"
          ></b-form-input>
        </b-col>
      </b-row>
    
      <b-row>
        <b-col cols="12" class="text-center padding-two-top">
          <b-button class="bg-orange-btn" type="submit">
            <font-awesome-icon icon="save" /> Guardar
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  name: "EditService",
  
  data() {
    return {
      formEdit: {},
    };
  },
  props:{
    company: {
      type: String,
    },
    sku: {
      type: String,
    },
    description: {
      type: String,
    },
    showModalEditSku:{
      type:Boolean
    },
    value:{
      type:Boolean
    }
  },
  computed: {
    bvalue: {
      get() { return this.value },
      set(value) { this.$emit('input', value) }
    },
    ...mapState("module", ["username","token"]),
  },
  created() {
    //this.getSku();
  },
  methods: {
   
    async edit() {
      event.preventDefault();
      try {
        this.$store.commit("SET_LOADING", true);

        let response = await axios.put(
          process.env.VUE_APP_SERVICES_CORE_BASE +
            "/services/" +
            this.sku,
          {
            sku:this.sku,
            description:this.description,
            company:this.company
          },
          {
            headers: {
              "Content-type": "application/json",
              "Authorization": "Bearer "+ this.token
            },
          }
        );
        console.log(response);
        this.$emit("update:showModalEditSku", false);
        let values = { variant: "success", msg: "Se actualizó exitosamente !" };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
      } catch (error) {
        console.log(error);
        let values = { variant: "danger", msg: error.response.data.message };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
      } finally {
        this.$store.commit("SET_LOADING", false);
        setTimeout(() => this.$store.commit("setShowAlert", false), 3000);
      }
    },
  },
};
</script>
<style scoped>
.padding-two-top {
  padding-top: 2%;
}
::v-deep .modal-title {
  color: #ff7a00 !important;
  font-weight: 500;
}

.text-grey {
  color: #676767;
  font-size: 15px;
  letter-spacing: 0px;
  display: block;
  margin-bottom: 0;
}
::v-deep .modal-title {
  color: #ff7a00 !important;
  font-weight: 500;
}
</style>
